import { render, staticRenderFns } from "./UploadJobFile.vue?vue&type=template&id=fad5d284&scoped=true"
import script from "./UploadJobFile.vue?vue&type=script&lang=ts"
export * from "./UploadJobFile.vue?vue&type=script&lang=ts"
import style0 from "./UploadJobFile.vue?vue&type=style&index=0&id=fad5d284&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad5d284",
  null
  
)

export default component.exports